import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface INotificationState {
  type: "success" | "info" | "warning" | "error";
  message: string;
  duration?: number;
  isOpen?: boolean;
}

const initialState: INotificationState = {
  type: "success",
  message: "",
  isOpen: false,
  duration: 3500,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setMessage: (state, action: PayloadAction<INotificationState>) => {
      state.type = action.payload.type;
      state.message = Array.isArray(action.payload.message)
        ? action.payload.message[0]
        : action.payload.message;
      state.duration = action.payload?.duration
        ? action.payload?.duration
        : 3500;
      state.isOpen = true;
    },
    resetMessage: (state) => {
      if (state.isOpen) {
        state.type = "success";
        state.message = "";
        state.duration = 0;
        state.isOpen = false;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { setMessage, resetMessage } = notificationSlice.actions;

export default notificationSlice.reducer;
